import { render, staticRenderFns } from "./PlotPage.vue?vue&type=template&id=2abb50b2&scoped=true"
import script from "./PlotPage.vue?vue&type=script&lang=ts"
export * from "./PlotPage.vue?vue&type=script&lang=ts"
import style0 from "./PlotPage.vue?vue&type=style&index=0&id=2abb50b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb50b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abb50b2')) {
      api.createRecord('2abb50b2', component.options)
    } else {
      api.reload('2abb50b2', component.options)
    }
    module.hot.accept("./PlotPage.vue?vue&type=template&id=2abb50b2&scoped=true", function () {
      api.rerender('2abb50b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/PlotPage.vue"
export default component.exports